<template>
    <v-app id="app">
        <div id="navigation">
            <h1>
                <v-row no-gutters>
                    <v-col class="primary--text">
                        <strong>
                            Control Surface
                        </strong>
                        for Spotify
                    </v-col>
                    <v-col
                        cols="2"
                        id="navigation_controls"
                        class="text-align--right"
                    >
                        <v-btn icon color="accent" @click="toggle_theme">
                            <v-icon>mdi-theme-light-dark</v-icon>
                        </v-btn>
                        <v-btn icon color="accent" @click="notes_dialog = true">
                            <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            color="accent"
                            @click="signout_confirmation_dialog = true"
                            v-if="$spotify_credentials.access_token !== ''"
                        >
                            <v-icon>mdi-exit-to-app</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </h1>
        </div>

        <router-view class="vr-view" />

        <v-dialog v-model="notes_dialog" width="500" scrollable>
            <v-card>
                <v-card-title>
                    Notes
                    <v-spacer />
                    <v-btn icon @click="notes_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-expansion-panels accordion>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                About
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <p>
                                    Control Surface for Spotify is a utility to
                                    allow users to control their Spotify
                                    playback without opening the web version of
                                    Spotify. It aims to be a simple, easy-to-use
                                    application to control playback and view
                                    currently playing information.
                                </p>
                                <p>
                                    Control Surface for Spotify is developed by
                                    <a
                                        href="https://hkamran.com"
                                        target="_blank"
                                        class="accent--text"
                                        >H. Kamran</a
                                    >.
                                </p>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Keyboard Shortcuts
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <p>
                                    A number of keyboard shortcuts have been
                                    integrated into Control Surface for Spotify
                                    for greater ease of use.
                                </p>
                                <v-list dense flat>
                                    <v-list-item>
                                        Play/Pause: Spacebar
                                    </v-list-item>
                                    <v-list-item>
                                        Skip Next: Next Arrow
                                    </v-list-item>
                                    <v-list-item>
                                        Skip Previous: Left Arrow
                                    </v-list-item>
                                    <v-list-item>
                                        Save/Unsave Song: Command/Control + S
                                    </v-list-item>
                                    <v-list-item>
                                        Toggle Shuffle: S
                                    </v-list-item>
                                    <v-list-item>
                                        Toggle Repeat: R
                                    </v-list-item>
                                    <v-list-item>
                                        Increase Volume: Up Arrow
                                    </v-list-item>
                                    <v-list-item>
                                        Decrease Volume: Down Arrow
                                    </v-list-item>
                                    <v-list-item>
                                        Open Devices Dialog: D
                                    </v-list-item>
                                    <v-list-item>
                                        Open Playlists Dialog: P
                                    </v-list-item>
                                    <v-list-item>
                                        Open Playlist Track List: T
                                    </v-list-item>
                                    <v-list-item>
                                        Open Volume Dialog: V
                                    </v-list-item>
                                    <v-list-item>
                                        Open Notes Dialog (this dialog): N
                                    </v-list-item>
                                    <v-list-item>
                                        Close Currently Open Dialog: Escape
                                    </v-list-item>
                                    <v-list-item>
                                        Toggle Theme: Shift + T
                                    </v-list-item>
                                    <v-list-item>
                                        Signout: Shift + W
                                    </v-list-item>
                                </v-list>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Notes
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <p>
                                    In order to not trigger rate limiting,
                                    Control Surface for Spotify checks Spotify
                                    for changes every 2500 milliseconds (2.5
                                    seconds).
                                </p>
                                <v-divider class="pb-3" />
                                <p>
                                    Only the first twenty playlists are loaded
                                    from your Spotify account.
                                </p>
                                <v-divider class="pb-3" />
                                <p>
                                    UNISON Technologies is in no way affiliated
                                    with Spotify AB.
                                </p>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="signout_confirmation_dialog" width="500" persistent>
            <v-card>
                <v-card-title>
                    Are you sure you want to signout?
                </v-card-title>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        color="success"
                        @click="signout_confirmation_dialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn text color="error" @click="signout">
                        Signout
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
export default {
    name: "App",
    data: function() {
        return {
            notes_dialog: false,
            signout_confirmation_dialog: false
        };
    },
    created() {
        this.$event_hub.$on("open-notes", () => {
            this.notes_dialog = true;
        });
        this.$event_hub.$on("close-notes", () => {
            this.notes_dialog = false;
        });
        this.$event_hub.$on("toggle-theme", () => {
            this.toggle_theme();
        });
        this.$event_hub.$on("signout", () => {
            this.signout_confirmation_dialog = true;
        });
        this.$event_hub.$on("close-signout-confirmation", () => {
            this.signout_confirmation_dialog = false;
        });
    },
    mounted() {
        const theme = localStorage.getItem("dark_theme");
        if (theme) {
            // deepcode ignore UseStrictEquality: Loaded as a String, not a Boolean
            if (theme == "true") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        } else if (
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
            this.$vuetify.theme.dark = true;
            localStorage.setItem(
                "dark_theme",
                this.$vuetify.theme.dark.toString()
            );
        }
    },
    methods: {
        toggle_theme: function() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.setItem(
                "dark_theme",
                this.$vuetify.theme.dark.toString()
            );
        },
        signout: function() {
            this.signout_confirmation_dialog = false;

            this.$spotify_credentials.access_token = "";
            this.$spotify_credentials.refresh_token = "";
            this.$spotify_credentials.expires_in = false;

            this.$router.push({ path: "/authorize", query: { signout: true } });
        }
    }
};
</script>

<style>
#app {
    font-family: Lato, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#navigation {
    padding: 30px 35px;
}

#navigation #navigation_controls button.v-btn {
    margin: 0 7.5px;
}

.vr-view {
    width: 100vw;
}

/* Text Classes */
.text-align--right {
    text-align: right;
}
.text-align--center {
    text-align: center;
}
.text-size--small {
    font-size: 12px;
}
</style>
